import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";

export const authApi = createApi({
  reducerPath: "authApi",
  // configuring baseQuery
  baseQuery: fetchBaseQuery({
    // baseUrl: "https://gg5s3lsr-3000.inc1.devtunnels.ms/",
    baseUrl: "/api/", // same-origin: the UI is served by the same Express app as the API
    // baseUrl: "http://localhost:3005/api/",
    // baseUrl: "https://praanwebsitebackend.azurewebsites.net/",
    prepareHeaders: (headers, { getState }) => {
      console.log("getState", getState);
      if (localStorage.getItem("user")) {
        const token = JSON.parse(localStorage.getItem("user") || "").token;
        if (token) {
          headers.set("authorization", `Bearer ${token}`);
        }
      }
    },
  }),
  endpoints: (builder) => ({
    // login api call
    login: builder.mutation({
      query: (body) => {
        return {
          url: "/auth/login",
          method: "post",
          body,
        };
      },
      transformResponse: (response) => {
        return response.data;
      },
      transformErrorResponse: (response) => {
        console.log("erorasda", response);
        return response.data;
      },
    }),
    // signup api call
    createUser: builder.mutation({
      query: (body) => {
        return {
          url: "/auth/createUser",
          method: "post",
          body,
        };
      },
      transformResponse: (response) => {
        return response.data;
      },
      transformErrorResponse: (response) => {
        console.log("erorasda", response);
        return response.data;
      },
    }),
    getUsers: builder.mutation({
      query: () => {
        return {
          url: "/auth/users",
          method: "get",
        };
      },
      transformResponse: (response) => {
        console.log("users list", response);
        return response.data;
      },
      transformErrorResponse: (response) => {
        console.log("error users list", response);
        return response.data;
      },
    }),
    deleteUser: builder.mutation({
      query: (userId) => {
        return {
          url: `/auth/users/${userId}`,
          method: "delete",
        };
      },
      transformResponse: (response) => {
        console.log("delete user", response);
        return response?.data;
      },
      transformErrorResponse: (response) => {
        console.log("error delete user", response);
        return response.data;
      },
    }),
  }),
});

export const {
  useLoginMutation,
  useCreateUserMutation,
  useGetUsersMutation,
  useDeleteUserMutation,
} = authApi;
